import { Box, Stack, Typography } from "@mui/material";
import { Spacing } from "Infrastructure/Themes/Themes";
import { alignWithGoalName } from "./GoalCardHeader";
import type { GoalCardFact } from "./utils/goalCardFacts";

type Props = {
  facts: GoalCardFact[];
  isCompleted: boolean;
  isTablet: boolean;
};

export const GoalCardFacts = ({ facts, isCompleted, isTablet }: Props) => (
  <Box
    display="grid"
    gridTemplateColumns={isTablet ? "minmax(0, 1fr)" : "repeat(2, minmax(0, 1fr))"}
    columnGap={Spacing.XL}
    rowGap={Spacing.L}
    sx={(theme) => ({ pl: alignWithGoalName(theme) })}
  >
    {facts.map(({ label, value }) => (
      <Stack key={label} gap={Spacing.S}>
        <Typography fontSize={11} fontWeight={500} color="text.secondary" textTransform="uppercase" letterSpacing="0.06em">
          {label}
        </Typography>
        <Typography fontSize={15} color={isCompleted ? "grey.700" : "text.primary"}>
          {value}
        </Typography>
      </Stack>
    ))}
  </Box>
);
